var languageConfig = {
  en: {
    cart: "Cart",
    logout: "Logout",
    login: "Login",
    where: "Where's My Order?",
    my_account: "My Account",
    register: "Register",
    search_deal: "Search Deals",
    deal: "Deal",
    choose_region: "Choose Region/City",
    view: "View",
    product_view: "See Details",
    auction_view: "See Details",
    load_more_deals: "Load More Deals",
    about_us: "About Us",
    contact_us: "Contact Us",
    become_a_partner: "Become A Partner",
    email_subscription: "Email Subscription",
    faqs: "FAQs",
    dashboard: "Dashboard",
    term_and_condition: "Terms And Conditions",
    privacy_policy: "Privacy Policy",
    copyright: "Copyright",
    subscribe: "Subscribe",
    subscribe_mailing: "Subscribe to our mailing list",
    ct_protc_pwd_ttl: "Add Password for",
    ct_protc_pwd_hd_1: "Thanks for visiting ",
    ct_protc_pwd_hd_2:
      ". Please input the password you received below in order to access our offers.",
    ct_protc_pwd_text: "Thanks for being a valued customer!",
    value: "Value",
    discount: "Discount",
    savings: "Savings",
    add_to_cart: "Add To Cart",
    details: "Details",
    fine_print: "Fine Print",
    locations: "Location(s)",
    Location: "Location",
    question: "Question",
    reviews: "Reviews",
    give_as_gift: "Give as a gift",
    place_auction_bid: "Place Bid",
    buy_auction_now: "Buy Now",
    product_purchased_0: "Products",
    auction_purchased_0: "Bids",
    auction_placed_1: "Placed",
    deals_purchased_0: "Deals",
    deals_purchased_1: "Purchased",
    send_as_gift: "Send this as a gift",
    recipent_name: "Recipent Name",
    enter_name: "Enter Name",
    recipent_email: "Recipent Email",
    enter_email: "Enter Email",
    enter_confirm_email: "Enter Confirm Email",
    quantity: "Quantity",
    qty: "Qty",
    personal_message: "Personal Message",
    upcoming_deal: "Upcoming Deals",
    coupon: "Coupon",
    //free_coupan			: 'Free Coupon',
    free_coupan: "Download Coupon",
    access: "Access",
    offer: "Offer",
    retail_price: "Retail Price",
    offer_price: "Offer Price",
    shipping: "Processing",
    tax: "Tax",
    total: "Total",
    action: "Action",
    grand_total: "Grand Total",
    continue_shopping: "Continue Shopping",
    checkout: "Checkout",
    sub_total: "Sub Total",
    confirm_order_check: "Confirm Your Order And Checkout",
    have_promo_code: "Have a promo code?",
    enter_save_even: "If so, enter it and save even more!",
    biling_information: "Billing Information",
    total: "Total",
    amount: "Amount",
    credit_debit_pay: "Credit/Debit Card Payment (Authorize.net)",
    chase_pay: "Credit/Debit Card Payment (Chase)",
    paypal_pay: "You will be redirected to Paypal",
    existing_credit_car: "Use the existing credit card already on file",
    store_billing: "Store your billing info for a speedier checkout next time?",
    cardholder_fname: "Cardholder's First Name",
    cardholder_lname: "Cardholder's Last Name",
    enter_first_name: "Enter First Name",
    enter_last_name: "Enter Last Name",
    credit_card_no: "Credit Card Number (no spaces or dashes)",
    expiration_date: "Expiration Date (mm/yy)",
    security_code: "Security Code (3 or 4 digits on the back of the card)",
    billing_address: "Billing Address",
    address: "Address",
    address2: "Address Line 2",
    city: "City",
    state: "State/Province",
    zip_code: "Zip/Postal Code",
    phone_no: "Phone Number",
    shipping_address: "Shipping Address",
    same_billing_addres: "Same as Billing Address",
    same_billing_name: "Same as Billing Name",
    tax_rate_applied_msg:
      "Tax Rate applied on Shipping Address. Please view updated Grand Total above.",
    completing_order_msg:
      "By completing this order, you agree to the offer terms and our terms and conditions.",
    pay_now: "Pay Now",
    checkout: "Checkout",
    item: "Item",
    item_attribute: "Item Attribute",
    gift_recipient_info: "Gift Recipent Shipping Information",
    get_details: "Gift Details",
    choose_region: "Choose Region/City",
    frequently_ask: "Frequently Asked Questions",
    click_question: "Click on the questions to view its answer",
    find_helpful: "Did you find this helpful?",
    yes: "Yes",
    no: "No",
    manage_subscripton: "Manage Subscriptions",
    cities: "Cities",
    cancel: "Cancel",
    business_name: "Business Name",
    web_address: "Web Address",
    user_name: "User Name",
    did_you_hear_about: "How did you hear about us?",
    contact_name: "Contact Name",
    city_interest: "City of Interest",
    email: "Email",
    phone: "Phone",
    offer_have_mind: "What type of offer do you have in mind?",
    online_retailer: "Are you an online retailer?",
    submit_business: "Submit Business",
    contact_us: "Contact Us",
    availabe_credit: "Available Credit",
    vouchers: "Vouchers",
    archivevouchers: "Archive Vouchers",
    my_coupans: "Coupons",
    order_detail: "Order Details",
    edit_profile: "Edit Profile",
    change_password: "Change Password",
    referral: "Referral",
    merchant_offer: "Merchant/Offer",
    expiration: "Expiration",
    redeem_date: "Redeem Date",
    redeem_value: "Redeem Value",
    action: "Action",
    print: "Print",
    offer: "Offer",
    amount_charged: "Amount Charged",
    credit_used: "Credit Used",
    placed_on: "Placed On",
    card_number: "Card Number",
    country: "Country",
    subscriber_city: "Subscriber City",
    gender: "Gender",
    date_birth: "Date of Birth",
    update: "Update",
    save: "Save",
    check_order_status: "Check Order Status",
    delete_user: "Delete User Account",

    delete_user_button: "Delete Account",
    user_account_detail: "Account Detail.",
    tract_on_order:
      "Need to review or track an order? Enter your order information to see the status.",
    email_address: "Email Address",
    order_number: "Order Number",
    registered_customer: "Registered Customers",
    new_customer: "New Customers",
    register: "Register",
    password: "Password",
    lost_password: "Lost your password",
    forgot_password: "Forgot Your Password?",
    your_email_address: "Your Email Address",
    submit: "Submit",
    reset_password: "Reset Password",
    home: "Home",
    confirm_password: "Confirm Password",
    subscribe_to_mailing: "Subscribe to our mailing list",
    or: "OR",
    guest_checkout: "Guest Checkout",
    completing_purchase:
      "By completing your purchase, you agree to the Site Name terms of service and privacy policy.",
    gift_card_popup_0:
      "You are purchasing item to send as a gift. If you wish to buy for yourself, you must purchase separately.",
    gift_card_popup_1:
      "Your recipient will recieve an email on how to claim their gift after your account has been charged.",
    cart_page: "Your cart is empty. Please add some offers.",
    login_page_head:
      "If you have an account with us, log in using your email address. We'll never share your email with anyone else.",
    login_page_body:
      "By creating an account with our store, you will be able to move through the checkout process faster, store multiple shipping addresses, view and track your orders in your account and more.",
    checkout_success: "Success! You’ve Scored the Deal!!",
    data_not_found: "Deal not found",
    term: "Terms",
    note: "Note",
    attribute: "Attribute",
    promotional_code: "Promotional Code",
    enter_propmocode: "Enter Promo Code",
    apply: "Apply",
    remove: "Remove",
    enter_phone_no: "Enter Phone Number",
    first_name: "First Name",
    last_name: "Last Name",
    order_id: "Order ID",
    voucher_number: "Voucher Number",
    tracking_number: "Tracking Number",
    title: "Title",
    status: "Status",
    old_password: "Old Password",
    referral_link: "Your referral link is",
    copy: "Copy",
    select_all_city: "Select All City",
    charity: "Charity",
    select_charity: "Please select charity",
    choose_preferred: "Choose your preferred email frequency",
    daily: "Daily",
    weekly: "Weekly",
    twice_month: "Twice In Month",
    unsubscribe: "Unsubscribe",
    personal_information: "Personal Information",
    format: "Format",
    confirm_email: "Confirm Email",
    i_agree_reg: "I agree to siteName Terms of Use and Privacy Policy",
    create_account: "Create Account",
    no_faq_exit: "No FAQs Exist",
    thanks_feedback: "Thanks for your feedback!",
    connect_with_us: "Connect with us",
    send_request: "Send a Request",
    dont_miss_out: "Don't miss out! Get on our list",
    currently_dont: "Sorry, we currently don't have any offers in this market!",
    hope_more_soon: "Offers coming soon!",
    must_be_logged:
      "You must be logged in to checkout. Or checkout as a guest user.",
    give_review: "Give Your Review",
    rating: "Rating",
    edit_your_review: "Edit Your Review",
    ask_your_question: "Ask Your Question",
    submit_question: "Submit Question",
    free_text: "FREE",
    proposal_coupon: "Coupon",
    comming_soon: "Coming Soon",
    sold_out: "Sold Out",
    this_option_sold_out: "This option is sold out.",
    auction_ended: "Auction Ended",
    time_remaining: "Offer Goes Live In",
    end_remaining: "Offer Ends In",
    deal_highlights: "Deal Highlights",
    bid_highlights: "Bid Details",
    current_bid: "Your current bid",
    auction_current_bid: "Auction current bid",
    auction_win_status: "You're currently winning",
    auction_win_status1: "You need to bid again",
    qty_left: "Quantity Left",
    close: "Close",
    select_category: "Select Category",
    dublicate_user_key:
      "We apologize for the inconvenience, please refresh the page and try again.",
    gift_cards: "Gift Cards",
    mailed: "Mailed",
    generated: "Giveaways",
    pick_up_information: "Pick Up Information",
    pick_up_notes1: "Please specify who will be picking up the tickets.",
    pick_up_notes2:
      "Be sure you or your designated personbrings a photo ID when picking up the tickets.",
    success: "success",
    update_password: "Your password updated successfully. Please login!",
    password_match: "Confirm password and password must match!",
    warning: "warning",
    login_information: "Login Information",
    never_expires: "Never Expire",
    not_redeemed: "Not redeemed",
    redeemed: "Redeemed",
    optin_placeholder_text: "Your email address",
    click_to_select: "Click To Select",
    SelectAtrribute: "Select Attribute",
    redeem_voucher1: "Redeem Voucher",
    do_not_mark:
      "Do not mark redeemed until ready to use at merchant location.",
    voucher_amount: "Voucher Amount",
    redeemed_amount: "Redeemed Amount",
    redeem_amount: "Redeem Amount",
    remaining_amount: "Remaining Amount",
    offer_name: "Offer Name",
    merchant_name: "Merchant Name",
    voucher_value: "Voucher Value",
    purchase_price: "Purchase Price",
    purchase_date: "Purchase Date",
    expiry_date: "Expiration Date",
    amount_remaining: "Amount Remaining",
    voucher_status: "Voucher Status",
    customer_spend: "Total Customer Spend Amount",
    payway_pay: "Credit/Debit Card Payment (PayWay)",
    stripe_pay: "Credit/Debit Card Payment (Stripe)",
    mark_used: "Mark as Used",
    optional: "Optional",
    redeem: "Redeem",
    view_details: "View Details",
    active: "Active",
    only_merchant_label: "Merchant",
    click_to_select_viewdetail: "Click To Select Offers",
    SelectAtrributeViewDetail: "Select Option and Attribute",
    you_may_also_like: "You May Also Like",
    first_button: "First",
    last_button: "Last",
    voucherstextplace:"Voucher number or Vouchers text",
  },
  fr: {
    cart: "Panier",
    logout: "Déconnexion",
    login: "Connexion",
    where: "Où est ma commande?",
    my_account: "Mon compte",
    register: "Inscription",
    deal: "Offre",
    search_deal: "Recherchez nos offres",
    choose_region: "Choisir une région",
    view: "Voir l'offre",
    product_view: "Voir les détails",
    auction_view: "Voir les détails",
    load_more_deals: "Voir plus d'offres",
    about_us: "À propos",
    contact_us: "Nous joindre",
    become_a_partner: "Devenez un partenaire",
    email_subscription: "Abonnement courriel",
    faqs: "Foire aux questions (FAQ)",
    dashboard: "Tableau de bord",
    term_and_condition: "Termes et conditions",
    privacy_policy: "Politique de vie privée",
    copyright: "Copyright / Propriété intellectuelle",
    subscribe: "S’abonner",
    subscribe_mailing: "Abonnez-vous par courriel pour recevoir nos offres",
    ct_protc_pwd_ttl: "Add Password for",
    ct_protc_pwd_hd_1: "Thanks for visiting ",
    ct_protc_pwd_hd_2:
      ". Please input the password you received below in order to access our offers.",
    ct_protc_pwd_text: "Thanks for being a valued customer!",
    value: "Valeur",
    discount: "Rabais",
    savings: "Économies",
    add_to_cart: "Ajouter au panier",
    details: "Détails",
    fine_print: "Conditions d'utilisation",
    locations: "Emplacement(s)",
    location: "Emplacement",
    question: "Questions",
    reviews: "Avis",
    give_as_gift: "Offrir en cadeau",
    place_auction_bid: "faire une offre",
    buy_auction_now: "Acheter maintenant",
    product_purchased_0: "produits",
    auction_purchased_0: "Enchères",
    auction_placed_1: "Mis",
    deals_purchased_0: "Offres",
    deals_purchased_1: "achetées",
    send_as_gift: "Envoyez ceci en cadeau",
    recipent_name: "Nom du destinataire",
    enter_name: "Saisir nom",
    recipent_email: "Courriel du destinataire",
    enter_email: "Saisir courriel",
    enter_confirm_email: "Enter Confirm Email",
    quantity: "Quantité",
    qty: "Qté",
    personal_message: "Message personnalisé",
    upcoming_deal: "Offres à venir",
    coupon: "Bon rabais",
    //free_coupan			: 'Bon rabais gratuit',
    free_coupan: "Télécharger le coupon",
    access: "Accès",
    offer: "Offre ",
    retail_price: "Prix du détaillant",
    offer_price: "Prix avec rabais",
    shipping: "Frais de livraison",
    tax: "Taxes",
    total: "Total",
    action: "Action",
    grand_total: "Montant total",
    continue_shopping: "Poursuivre vos achats",
    checkout: "Passer la commande",
    sub_total: "Sous-total",
    confirm_order_check: "Détails de la commande et paiement ",
    have_promo_code: "Vous avez un code promotionnel?",
    enter_save_even: "Saisir le code et économiser encore plus!",
    biling_information: "Informations de facturation",
    total: "Total",
    amount: "Montant",
    credit_debit_pay: "Paiement par carte de crédit / débit (Authorize.net)",
    chase_pay: "Paiement par carte de crédit / débit (Chase)",
    paypal_pay: "Passerelle de paiement PayPal",
    existing_credit_car: "Utilisez la carte de crédit déjà enregistrée",
    store_billing:
      "Conserver vos informations de facturation pour un paiement plus rapide?",
    cardholder_fname: "Prénom du titulaire de la carte",
    cardholder_lname: "Nom du titulaire de la carte",
    first_name: "Saisissez le prénom",
    last_name: "Saisissez le nom",
    credit_card_no: "Numéro de la carte (sans espace ni tiret)",
    expiration_date: "Date d'expiration (mm/aa)",
    security_code:
      "Code de sécurité (3 ou 4 chiffres situés à l'endos de votre carte)",
    billing_address: "Adresse de facturation",
    address: "Adresse",
    address2: "Adresse Ligne 2",
    city: "Ville",
    state: "État/Province",
    zip_code: "ZIP/Code postal",
    phone_no: "Numéro de téléphone",
    shipping_address: "Adresse de livraison",
    same_billing_addres: "Même que l'adresse de facturation",
    same_billing_name: "Identique au nom de facturation",
    tax_rate_applied_msg:
      "Taux de taxe appliqué à l'adresse de livraison. Merci de revoir le «Montant total» actualisé",
    completing_order_msg:
      "En complétant votre achat, vous acceptez les modalités et conditions afférentes, telles qu'elles sont formulées, à l'utilisation de notre site.",
    pay_now: "Payer maintenant",
    checkout: "Passer au paiement",
    item: "Article",
    item_attribute: "Caractéristique",
    gift_recipient_info: "Informations de livraison du destinataire du cadeau",
    get_details: "Détails du cadeau",
    choose_region: "Choisissez la région",
    frequently_ask: "Foire aux questions",
    click_question: "Cliquez sur les questions pour voir les réponses",
    find_helpful: "Avez-vous trouvé cela utile?",
    yes: "Oui",
    no: "Non",
    manage_subscripton: "Gestion des abonnements",
    cities: "Villes",
    cancel: "Annuler",
    business_name: "Nom de l'entreprise",
    web_address: "Adresse du site",
    user_name: "Nom d'utilisateur",
    did_you_hear_about: "Comment avez-vous entendu parler de nous?",
    contact_name: "Nom de la personne contact",
    city_interest: "Région ciblée",
    email: "Courriel",
    phone: "Téléphone",
    offer_have_mind: "Quelle type d'offres avez-vous en tête?",
    online_retailer: "Êtes-vous un détaillant en ligne?",
    submit_business: "Soumettre votre entreprise",
    contact_us: "Nous joindre",
    availabe_credit: "Crédit disponible",
    vouchers: "Bon d'achats",
    my_coupans: "Coupons",
    order_detail: "Mes commandes ",
    edit_profile: "Modifier mon profil",
    change_password: "Changer mon mot de passe",
    referral: "Recommandation",
    merchant_offer: "Commerçant/Offre",
    expiration: "Échéance",
    redeem_date: "Date de réclamation",
    redeem_value: "Valeur de la réclamation",
    action: "Action",
    print: "Imprimer",
    offer: "Offre",
    amount_charged: "Montant facturé",
    credit_used: "Crédit utilisé",
    placed_on: "Effectué le",
    card_number: "Numéro de carte",
    country: "Pays",
    subscriber_city: "Région(s) sélectionnée(s) ",
    gender: "Genre",
    date_birth: "Date de naissance",
    update: "Mettre à jour",
    save: "Enregistrer",
    check_order_status: "Vérifier le statut de la commande",
    tract_on_order:
      "Besoin de vérifier une commande ou de consulter son statut?  Entrez vos informations ci-dessous:",
    email_address: "Courriel",
    order_number: "Numéro de commande",
    registered_customer: "Client inscrit",
    new_customer: "Nouveau client",
    register: "Inscription",
    password: "Mot de passe",
    lost_password: "Perdu votre mot de passe?",
    forgot_password: "Oublié votre mot de passe?",
    your_email_address: "Votre adresse courriel",
    submit: "Soumettre",
    reset_password: "Réintialiser le mot de passe",
    confirm_password: "Confirmer le mot de passe",
    subscribe_to_mailing: "Abonnez-vous à notre infolettre",
    or: "ou",
    guest_checkout: "Commander en tant qu'invité",
    completing_purchase:
      "En complétant votre achat, vous acceptez les modalités et conditions afférentes, telles qu'elles sont formulées, à l'utilisation de notre site.",
    gift_card_popup_0:
      "Vous achetez un article pour envoi-cadeau.  Si vous souhaitez acheter pour vous-même, vous devez faire un achat séparé.",
    gift_card_popup_1:
      "Une fois que votre compte aura été débité, votre destinataire recevra un courriel avec des indications pour la réclamation son cadeau.",
    cart_page: "Votre panier est vide.  Ajoutez-y des offres!",
    login_page_head:
      "Si vous avez un compte avec nous, utilisez votre adresse courriel pour la connexion.  Nous ne divulguerons jamais votre courriel à qui que ce soit.",
    login_page_body:
      "En créant un compte sur notre boutique, vous pourrez passer vos commandes plus rapidement, enregistrer plusieurs adresses de livraison, consulter et suivre vos commandes et plus encore.",
    checkout_success: "Félicitations!",
    data_not_found: "Offre introuvable",
    term: "Termes",
    note: "Note",
    attribute: "Attribut",
    promotional_code: "Code promotionnel",
    enter_propmocode: "Entrer votre code promo",
    apply: "Appliquer",
    remove: "Enlever",
    enter_phone_no: "Entrer votre numéro de téléphone ",
    first_name: "Prénom",
    last_name: "Nom",
    order_id: "Numéro de commande",
    voucher_number: "Numéro du chèque-cadeau",
    tracking_number: "Numéro de suivi",
    title: "Titre",
    status: "Statut",
    old_password: "Ancien mot de passe",
    referral_link: "Votre lien de référence est",
    copy: "Copie",
    select_all_city: "Choisir toutes les villes",
    charity: "Charité",
    select_charity: "Svp choississez votre charité",
    choose_preferred: "Sélectionné vos préférences de courriel",
    daily: "Chaque jour",
    weekly: "Chaque semaine",
    twice_month: "Deux fois par mois",
    unsubscribe: "Se désabonner",
    personal_information: "Information personnelle",
    format: "Format",
    confirm_email: "Confirmez votre courriel",
    i_agree_reg:
      "J'accepte les termes et condition d'utilisation et la politique de confidentialité",
    create_account: "Créer votre compte",
    no_faq_exit: "FAQ inexistante ",
    thanks_feedback: "Merci de votre commentaire",
    connect_with_us: "Écrivez-nous",
    send_request: "Envoyer une demande",
    dont_miss_out: "Ne manquez rien! Abonnez-vous à notre liste.",
    currently_dont: "Désolé, il n'y a pas d'offre présentement",
    hope_more_soon: "Offres à venir bientôt!",
    must_be_logged:
      "Vous devez être connecté pour procéder à l'achat. Ou, acheter en tant qu'invité. ",
    give_review: "Donnez votre opinion",
    rating: "Évaluations",
    edit_your_review: "Modifier votre évaluation",
    ask_your_question: "Soumettre une question",
    submit_question: "Soumettez votre question",
    free_text: "Gratuit",
    proposal_coupon: "Gratuit",
    comming_soon: "À venir bientôt",
    sold_out: "Épuisé",
    this_option_sold_out: "Cette option est épuisée.",
    auction_ended: "Enchère terminée",
    time_remaining: "Temps restants",
    end_remaining: "Temps de fin",
    deal_highlights: "Les avantages",
    bid_highlights: "Détails de l'offre",
    current_bid: "Votre offre actuelle",
    auction_current_bid: "Enchère en cours",
    auction_win_status: "Vous êtes actuellement en train de gagner",
    auction_win_status_1: "Vous devez enchérir à nouveau",
    qty_left: "Quantité restante",
    close: "Fermé",
    select_category: "Select Category",
    dublicate_user_key:
      "We apologize for the inconvenience, please refresh the page and try again.",
    gift_cards: "Bons-cadeaux",
    mailed: "Envoyé par la poste",
    generated: "Giveaways",
    pick_up_information: "ramasser des informations",
    pick_up_notes1: "Veuillez préciser qui récupérera les billets.",
    pick_up_notes2:
      "Assurez-vous que vous, ou votre personne désignée, présentez une pièce d'identité avec photo lors de la prise en charge des billets.",
    success: "success",
    update_password: "Mot de passe de l'utilisateur mis à jour avec succès.",
    password_match: "Confirm password and password must match!",
    warning: "warning",
    login_information: "Information de connexion",
    never_expires: "Pas de date d'expiration",
    not_redeemed: "Non échangé",
    redeemed: "Échangé",
    optin_placeholder_text: "Votre adresse courriel",
    click_to_select: "Click To Select",
    SelectAtrribute: "Select Attribute",
    redeem_voucher1: "VALIDER UN CHÈQUE-CADEAU", //'Utiliser le bon',
    do_not_mark: "Validez seulement lors de l'utilisation chez le commerçant", //'Ne marquez pas le remboursement tant qu\'il n\'est pas prêt à être utilisé chez le marchand.',
    voucher_amount: "Montant du bon d'achat",
    redeemed_amount: "Montant remboursé",
    redeem_amount: "Racheter le montant",
    remaining_amount: "Montant restant",
    offer_name: "Nom de l'offre",
    merchant_name: "Nom du commerçant",
    voucher_value: "Valeur du chèque-cadeau",
    purchase_price: "Prix ​​d'achat",
    purchase_date: "date de l'achat",
    expiry_date: "Date d'expiration",
    amount_remaining: "Quantité restante",
    voucher_status: "Status du chèque-cadeau",
    customer_spend: "Montant total de la transaction", //'Montant total des dépenses des clients',
    payway_pay: "Paiement par carte de crédit / débit (PayWay)",
    stripe_pay: "Paiement par carte de crédit / débit (Stripe)",
    mark_used: "Marquer comme utilisé",
    optional: "optionnel",
    redeem: "Valider",
    view_details: "Voir les détails de ce chèque-cadeau",
    active: "Actif",
    only_merchant_label: "Marchand",
    click_to_select_viewdetail: "Click To Select Offers",
    SelectAtrributeViewDetail: "Select Option and Attribute",
    you_may_also_like: "Pourrait aussi vous intéresser",
    first_button: "Précédente",
    last_button: "Suivante",
    delete_user: "Supprimer le compte utilisateur",
    delete_user_button: "Supprimer le comptet",
    user_account_detail: "Détail du compte.",
    voucherstextplace:"Numéro du bon ou texte du bon",
  },
};

module.exports = languageConfig;



// WEBPACK FOOTER //
// ./src/app/config/languageConfig.js